import {mixins} from "../app/mixin";

mixins.push({
    el: '.lifeInSemtrioPage',
    data() {
        return {
            scrollPosition: null,
            selectedBenefit: 0,
            selectedCompanyEvent: 0,
            selectedFlag: 0,
            eventsLength: window.eventsLength
        }
    },
    methods: {
        selectBenefit(benefitId) {
            if (this.selectedBenefit !== benefitId) {
                this.selectedBenefit = benefitId
            }
        },
        nextCompanyEvent() {
            if (
                this.eventsLength > 1 &&
                this.selectedCompanyEvent < this.eventsLength - 1
            ) {
                this.selectedCompanyEvent++
            }
        },
        prevCompanyEvent() {
            if (this.eventsLength > 1 && this.selectedCompanyEvent > 0) {
                this.selectedCompanyEvent--
            }
        },
        nextSlide() {
            if (this.selectedFlag < 4) {
                this.selectedFlag++
            }
        },
        previousSlide() {
            if (this.selectedFlag > 0) {
                return this.selectedFlag--
            }
        },
    }
});